import type {
  CreateManagedReservationRequestDto,
  CreateWaitlistEntryRequestDto,
  PromoteWaitlistEntryRequestDto,
  RecordReservationDepositRequestDto,
  SendReservationConfirmationRequestDto,
} from "./contracts/dtos.ts";
import type { ReservationConfirmationEmailProvider } from "./email.ts";
import {
  createManagedReservation,
  createWaitlistEntry,
  promoteWaitlistEntry,
  recordReservationDeposit,
  sendReservationConfirmation,
} from "./service.ts";
import type { ReservationManagementContext, ReservationRecord, ReservationWaitlistEntry } from "./types.ts";

export const reservationManagementEndpoints = {
  createReservation: (request: CreateManagedReservationRequestDto, context: ReservationManagementContext, deps: { idFactory: (prefix: string) => string }) =>
    createManagedReservation(request, context, deps),
  recordDeposit: (reservation: ReservationRecord, request: RecordReservationDepositRequestDto, now: string, deps: { idFactory: (prefix: string) => string }) =>
    recordReservationDeposit(reservation, request, now, deps),
  sendConfirmation: (
    reservation: ReservationRecord,
    request: SendReservationConfirmationRequestDto,
    provider: ReservationConfirmationEmailProvider,
    now: string,
    deps: { idFactory: (prefix: string) => string; guestLabel: string }
  ) => sendReservationConfirmation(reservation, request, provider, now, deps),
  createWaitlistEntry: (request: CreateWaitlistEntryRequestDto, now: string, deps: { idFactory: (prefix: string) => string }) =>
    createWaitlistEntry(request, now, deps),
  promoteWaitlistEntry: (
    request: PromoteWaitlistEntryRequestDto,
    context: ReservationManagementContext & { waitlistEntry: ReservationWaitlistEntry },
    deps: { idFactory: (prefix: string) => string }
  ) => promoteWaitlistEntry(request, context, deps),
};
